import React from 'react';
import { RiCamera3Line } from 'react-icons/ri';
import Styles from '../DealCard.module.scss';
import { formatDate } from '~/utils/DateUtil';
import { useDealInspectionReportImages } from '~/hooks/deals/useDealInspectionReportImages';
import { useDeals } from '~/hooks/useDeals';
import { matchDealType } from '~/models/Deal';
import { InspectionCandidateDate } from '~/models/InspectionCandidateDate';
import { EditMenuButton } from '~/components/common/parts/button/EditMenuButton';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';
import { ScheduleInputModal } from '~/components/common/inspection_candidate_dates/ScheduleInputModal';
import { useOpenHandler } from '~/hooks/useOpenHandler';

export const DealInspectionClientCard: React.FC = () => {
  const id = useIdQueryHandler();
  const { isOpen, handleOpen, handleClose } = useOpenHandler();
  const { data: deal, mutate: mutateDeal } = useDeals().show(id);
  const { data: reportImages } = useDealInspectionReportImages().index(id);
  if (reportImages === null || deal === null) {
    return null;
  }
  const handleMutate = async (): Promise<void> => {
    mutateDeal && (await mutateDeal());
  };
  const { dealInspectionCandidateDates: candidateDates } = deal;
  return (
    <div className={Styles.DealCard}>
      <h3 className={Styles.Title}>
        <RiCamera3Line className={Styles.TitleIcon} />
        <span>
          {`${matchDealType(deal, 'restoration') ? '退去' : '現場'}立会`}
        </span>
        {reportImages.length > 0 ? (
          <span className={Styles.InspectedLabel}>実施済</span>
        ) : (
          <span className={Styles.YetInspectLabel}>未実施</span>
        )}
        {deal.inspectionDate == null && (
          <div className={Styles.EditButtonWrapper}>
            <EditMenuButton onClick={handleOpen}>変更</EditMenuButton>
            <ScheduleInputModal
              deal={deal}
              handleClose={handleClose}
              handleMutate={handleMutate}
              isOpen={isOpen}
            />
          </div>
        )}
      </h3>
      <div className={Styles.Content}>
        <dl className={Styles.ListContent}>
          <dt className={Styles.ListContentCaption}>
            {`${matchDealType(deal, 'restoration') ? '退去' : '現場'}立会`}
          </dt>
          <dd className={Styles.ListContentValue}>
            {deal.inspectionDate == null ? (
              <span className={Styles.NotYet}>未定</span>
            ) : (
              <span>{formatDate(deal.inspectionDate, true)}</span>
            )}
          </dd>
        </dl>
        {candidateDates.map(
          (candidateDate: InspectionCandidateDate): React.ReactNode => (
            <dl key={candidateDate.id} className={Styles.ListContent}>
              <dt className={Styles.ListContentCaption}>
                第{candidateDate.sort}希望
              </dt>
              <dd className={Styles.ListContentValue}>
                <span className={Styles.Date}>
                  {formatDate(candidateDate.date)}
                </span>
                {candidateDate.time}
              </dd>
            </dl>
          )
        )}
      </div>
    </div>
  );
};
